export { default } from './LoanFeesHead';
